import { atom } from 'nanostores';

import type { HydraRealtimeBridge } from './bridge';

/**
 * Hydra's realtime bridge while this tab is connected on a Design Studio page; null otherwise.
 * `RealtimeProvider` sets it, and Design Studio's collaboration reads it.
 */
export const realtimeBridgeStore = atom<HydraRealtimeBridge | null>(null);
